import LoadingIndicator from "@simble/ui/loading-indicator";
import { Toaster } from "@simble/ui/toast";
import { createRootRouteWithContext, HeadContent, Outlet } from "@tanstack/react-router";
import React from "react";
import NotFoundPage from "@/components/not-found-page";
import type { store } from "@/store/local-store";

type RouterContext = {
  store: typeof store;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({
    meta: [
      { title: "Партнерский кабинет" },
      {
        name: "description",
        content: "Оформление страховки КАСКО на парковке",
      },
    ],
  }),
  component: () => (
    <React.Suspense fallback={<LoadingIndicator />}>
      <HeadContent />
      <Outlet />
      <Toaster />
    </React.Suspense>
  ),
  notFoundComponent: NotFoundPage,
});
